import React from "react"

import RichText from "./rich-text"

export default ({ content }) => {
  let text = <div/>
  if(content.imageCredit !== undefined) {
    content.imageCredit.json = content.imageCredit
    text = <RichText className="caption" content={ content.imageCredit }/>
  }
  if (content.image.file !== undefined) {
    return (
      <div
        className="image"
        style={
          { backgroundImage: `url(https:${content.image.file.url})`}
        }
        alt="placeholder"
      >
        { text }
      </div>
    )
  } else {
    return (
      <div/>
    )
  }
}
